/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dialog-wrapper{align-items:center;display:flex;justify-content:center;overflow:hidden;position:fixed;left:0;right:0;top:0;z-index:40;width:100%;height:100%}.modal-card-body{background-color:#fff;display:block;overflow:auto;max-height:88vh;-webkit-overflow-scrolling:touch}.dialog-content__container .dialog-content__inner-container{display:block;padding:14px 24px}.dialog-content__title{font-size:18px;font-weight:700;color:#0669b2;margin:0 0 20px;display:block}"];
export { styles as styles };
